interface ClientCreditNoteSaf {
  estado?: string | null;
  isAjustePorVariacion?: boolean | null;
  monto?: number | string | null;
  montoExcedente?: number | string | null;
  noContabilizarSAF?: boolean | null;
  tipo?: string | null;
}

interface ClientPaymentSaf {
  monto?: number | string | null;
  tipoAbono?: string | null;
}

const toFiniteNumber = (value: unknown): number => {
  const parsedValue = Number(value ?? 0);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

const roundMoney = (value: number): number =>
  Math.round((value + Number.EPSILON) * 100) / 100;

export const calculateGeneratedSaf = (
  creditNotes: ClientCreditNoteSaf[] | null | undefined
): number => {
  const generatedSaf = (creditNotes ?? []).reduce((total, creditNote) => {
    if (creditNote?.noContabilizarSAF === true) return total;
    if (creditNote?.tipo !== 'SALDO A FAVOR') return total;
    if (creditNote?.estado === 'ELIMINADO') return total;

    const excessAmount = toFiniteNumber(creditNote?.montoExcedente);
    const useExcessAmount =
      creditNote?.isAjustePorVariacion === true && excessAmount !== 0;
    const amount = useExcessAmount
      ? excessAmount
      : toFiniteNumber(creditNote?.monto);

    return total + amount;
  }, 0);

  return roundMoney(generatedSaf);
};

export const calculateConsumedSaf = (
  payments: ClientPaymentSaf[] | null | undefined
): number => {
  const consumedSaf = (payments ?? []).reduce((total, payment) => {
    if (payment?.tipoAbono !== 'SAF') return total;
    return total + toFiniteNumber(payment?.monto);
  }, 0);

  return roundMoney(consumedSaf);
};

export const calculateAvailableSaf = ({
  creditNotes,
  payments,
}: {
  creditNotes?: ClientCreditNoteSaf[] | null;
  payments?: ClientPaymentSaf[] | null;
}): number =>
  roundMoney(
    calculateGeneratedSaf(creditNotes) - calculateConsumedSaf(payments)
  );
